// extracted by mini-css-extract-plugin
module.exports = {"wdv8tbs":"wdv8tbs"};